import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import WhatToExpectSection from '../../Components/servicex/WhatToExpectSection';
import WeCanAlsoHelpWithSection from '../../Components/servicex/WeCanAlsoHelpWithSection';

const serviceItems = [
    {
        id: 1,
        title: "Real-time analytics and reporting for automation performance",
        description: "Streamline communication, onboarding, and lifecycle management across vendor networks with connected, transparent digital workflows.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Automation Center for centralized automation visibility and management",
        description: "Automate requisition approvals, contract analysis, and order execution to cut cycle times and eliminate manual bottlenecks.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Low-code Flow Designer for visual workflow creation",
        description: "Track enterprise expenditure, monitor third-party compliance, and benchmark supplier metrics through live, data-driven dashboards.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    }
];


const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Consulting",
        desc: "Our Automation Engine experts assess your current automation landscape, identify gaps, and define the right roadmap for success. We help you align integration strategies, RPA opportunities, and automation governance to operational efficiency and business objectives.",
        products: []
    },
    {
        id: 2,
        title: "Implementation",
        desc: "We deliver structured ServiceNow Automation Engine implementations that fit your business needs. From Integration Hub configuration and RPA bot deployment to Flow Designer workflows, Document Intelligence setup, and cross-system orchestration, we ensure rapid adoption and measurable productivity gains.",
        products: []
    },
    {
        id: 3,
        title: "Support and Maintenance",
        desc: "Our engagement extends beyond go-live. We deliver ongoing platform support, workflow optimization, and capability enhancements to ensure your Automation Engine evolves with business process changes, technology updates, and expanding automation opportunities.",
        products: []
    },
    {
        id: 4,
        title: "Resources and Pod",
        desc: "Scale your Automation Engine team with the right expertise, exactly when you need it. Aelum provides certified ServiceNow Automation Engine professionals on demand, whether you need short-term integration projects or a dedicated automation development pod.",
        products: []
    }
];


const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers drive digital innovation across production, maintenance, and supply chain operations through intelligent automation and AI-powered insights.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Our innovation frameworks enable financial institutions to modernize operations, enhance customer experiences, and maintain compliance in highly regulated environments.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "Retail organizations leverage our AI-driven innovation capabilities to improve customer engagement, optimize operations, and deliver seamless omnichannel experiences.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We help telecom providers innovate across customer service, network operations, and field service through intelligent workflows and scalable digital platforms.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "110+ Certifications",
        desc: "110+ Automation Engine and ServiceNow certifications across our team."
    },
    {
        id: 2,
        title: "AI-First Approach",
        desc: "AI-first approach to accelerate risk insights and response."
    },
    {
        id: 3,
        title: "Performance Optimization",
        desc: "Optimize Automation Engine performance, efficiency, and reduce manual effort."
    },
    {
        id: 4,
        title: "Custom Integrations",
        desc: "Customize Automation Engine workflows, features, and system integrations."
    }
];

const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "How does ServiceNow Automation Engine pricing work?",
        answer: "Automation Engine pricing is typically based on ServiceNow platform licensing and specific component usage. Pricing varies by deployment size, automation complexity, and required capabilities. Contact Aelum’s ServiceNow experts for customized pricing based on your automation requirements."
    },
    {
        id: 2,
        question: "Can we request a demo of ServiceNow Automation Engine?",
        answer: "Yes, you can schedule a tailored demonstration to explore how ServiceNow Automation Engine connects workflows, automates manual tasks, and accelerates operational efficiency across your enterprise."
    },
    {
        id: 3,
        question: "Is ServiceNow Automation Engine suitable for large enterprise legacy systems?",
        answer: "Yes, ServiceNow Automation Engine integrates seamlessly with legacy architectures using RPA bots, Integration Hub spokes, and custom APIs without requiring complete system overhauls."
    },
    {
        id: 4,
        question: "Can Aelum provide us on-demand resources for an automation project?",
        answer: "Yes, Aelum offers certified ServiceNow Automation Engine specialists, dedicated development pods, and flexible resource augmentation models to support both short-term projects and long-term enterprise programs."
    },
    {
        id: 5,
        question: "Which business processes should organizations prioritize for initial automation?",
        answer: "Organizations typically prioritize repetitive, high-volume, rule-based processes with well-defined steps, such as document processing, cross-system data synchronization, employee onboarding tasks, and standard approvals."
    }
];

const expectItems = [
    "Integration Hub",
    "RPA Hub",
    "Automation Center",
    "Document Intelligence",
    "Flow Designer",
    "Pre-Built Templates",
    "Analytics & Reporting",
    "Stream Connect for Apache Kafka"
];

function AutomationEngine() {
    return (
        <div>
            <WhoHero
                title="ServiceNow Automation Engine  Implementation Partner"
                text="Extend enterprise automation with AI-powered workflows, integrations, and RPA"
                imgData="/assets/glodesk/bg2.png"
            />
            {/* <UserFirstExperienceSection title="Supercharge enterprises with AI-Driven Innovation" description="Innovation today goes beyond experimenting with new technologies. Organizations need to turn ideas into solutions that improve operations, create better experiences, and drive measurable results. Many enterprises explore AI, automation, and digital tools but struggle to scale them across the business. Mobikode helps organizations move from experimentation to execution. By combining AI capabilities, intelligent automation, and digital engineering, we help enterprises build scalable solutions that improve efficiency, enable faster decisions, and support long-term growth." /> */}
            <ServiceX360ViewSection title="Reduce labor costs, increase efficiency & customer satisfaction with ServiceNow Automation Engine" description="Transform enterprise operations with ServiceNow Automation Engine. Aelum helps enterprises automate end-to-end workflows across departments through intelligent RPA, document intelligence, and seamless system integration. Our certified Automation Engine experts deploy solutions that drive consistent automation, strengthen data accuracy, and speed task completion across business-critical operations. Workflows and integrations are deployed rapidly with low-code tools, accelerating time-to-value while preserving existing technology investments.  " serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow Automation Engine Services" description="End-to-end support to implement, optimize, and scale enterprise automation with ServiceNow" />
            <WhatToExpectSection title="What to expect from Automation Engine" description="ServiceNow Automation Engine brings together sourcing, procurement, and finance into a unified experience:" expectItems={expectItems} />
            {/* <IndustriesServiceExperienceSection title="Accelerating Innovation Across Industries" industryTabs={industryTabs} /> */}
            <WeCanAlsoHelpWithSection />
            <WhatSetsApartSection title="Why Mobikode for ServiceNow Automation Engine? " description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default AutomationEngine
